* {
    box-sizing: border-box;
}

:host {
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    margin-bottom: 40px;
}

button {
    border: 0;
    margin: 0;
    padding: 0;
    width: 110px;
    display: flex;
    flex-direction: column;
    align-items: center;
    background-color: transparent;
    font: inherit;
    outline: none;
    color: var(--color-text);
    position: relative;
}

button .blob {
        height: 30px;
        width: 30px;
        border-radius: 50%;
        border: 2px solid var(--checkpoint-color);
        color: var(--checkpoint-color);
        margin-bottom: 12px;
        display: flex;
        align-items: center;
        justify-content: center;
    }

button .center {
        opacity: 0;
        transform: scale(0);
        transition-property: all;
        transition-duration: 500ms;
        transition-timing-function: ease;
    }

button:not(.readonly) {
        cursor: pointer;
    }

button:not(.readonly):hover .center, button:not(.readonly):focus .center {
                opacity: 1;
                transform: scale(0.5);
            }

button.active {
        cursor: default;
    }

button.active .center {
            opacity: 1;
            transform: scale(1);
        }

button.complete .center.custom {
        opacity: 1;
        transform: scale(1);
    }

.connection {
    margin: 0 -30px;
}

.connection line {
        transition-property: stroke;
        transition-duration: 500ms;
        transition-timing-function: ease;
    }

linearGradient stop {
    transition-property: stop-color;
    transition-duration: 500ms;
    transition-timing-function: ease;
}
